import styled from 'styled-components';

import { PurchaseDto } from 'services/order/orderService.dto';

import ButtonsSection from './ButtonsSection';
import LoggedUserDetails from './LoggedUserDetails';
import PurchaseDetails from './PurchaseDetails';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

interface Props {
  purchase: PurchaseDto;
  onConfirmed: () => void;
  onCanceled: () => void;
}

const BuyerReassignmentPopup = ({ purchase, onConfirmed, onCanceled }: Props) => {
  return (
    <Container>
      <LoggedUserDetails />
      <PurchaseDetails purchase={purchase} />
      <ButtonsSection onConfirmed={onConfirmed} onCanceled={onCanceled} />
    </Container>
  );
};

export default BuyerReassignmentPopup;
